import type { BoxProps } from "@mui/material";
import { Box } from "@mui/material";
import type { FC } from "react";
import type { MomentCardMoment } from "../types";
import { statusToPill } from "../utils";

interface MomentPillProps extends BoxProps {
  status: MomentCardMoment["status"];
}
export const MomentPill: FC<MomentPillProps> = ({ status, ...props }) => {
  if (!status) return null;
  return <Box {...props}>{statusToPill(status)}</Box>;
};
